<template lang="html">
    <div class="container">
        <div class="panel panel-default">
            <div class="panel-heading">{{shopInfo.name}}</div>
            <div class="panel-body">
                <div class="shop-info">
                    <div class="col-md-6">
                        <img :src="shopInfo.logo" alt="">
                    </div>
                    <div class="col-md-6">
                        <p v-html="shopInfo.introduce" style="font-size: 14px;"></p>
                        <p><span class="glyphicon glyphicon-phone-alt"></span>{{shopInfo.phone}}</p>
                        <p><span class="glyphicon glyphicon-earphone"></span>{{shopInfo.tel}}</p>
                        <p><span class="glyphicon glyphicon-map-marker"></span>{{shopInfo.city}}{{shopInfo.address}}</p>
                    </div>

                </div>

            </div>
        </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
                    <h4 class="modal-title" id="myModalLabel">Modal title</h4>
                </div>
                <div class="modal-body">
                    ...
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary">Save changes</button>
                </div>
            </div>
        </div>
    </div>


</template>
<script>
    import M from '../assets/common.js'
    import C from '../assets/config.js'
    export default {
        data: () => ({
            urlParams: M.getUrlParams(location.href),
            host: C.host,
            shopList: {},
            shopInfo:{},
            pageOpt: {
                list: {
                    pageNo: 1
                }
            },
            typeName: {},
            generalId: {}
        }),
        created: function() {
            var self = this;
            M.getAllType("admin", function(data) {
                self.$set('typeName', data);
                self.loadList();
            })
        },
        methods: {
            imgError: function(index) {
                // let book = bookList.list[index];
                // let book = this.bookList.list[index];
                this.$set('bookList.list[' + index + '].logo', 'http://qiniu.ludanmall.com/472/commend/logo/千库网-素材书图片_1480562667018.png');

            },
            // 查询店铺
            loadList: function() {
                let url = this.host + "wuyan/user/shop/all",
                    params = {

                    },
                    self = this;
                M.load(url, params, function(data) {
                    if (data.code) {
                        M.topRightInfoTips({
                            title: data.message
                        })
                    } else {
                        self.$set("shopList", data.data);
                        for(let i=0;i<self.shopList.list.length;i++){
                            if(self.shopList.list[i].id==self.urlParams.id){
                                self.$set("shopInfo",self.shopList.list[i])
                            }
                        }
                    }
                    self.$log();
                }, 'get');

            }

        }
    }
</script>


<style scoped>
    .container {
        margin-top: 40px
    }
    .glyphicon{
        margin: 0 10px
    }
    .shop-info{
        height: 300px;
        overflow: hidden
    }
     .shop-info img{
    }
    .shop-info p{
        font-size: 20px
    }
</style>


// WEBPACK FOOTER //
// shopInfo.vue?7f0a9209